// extracted by mini-css-extract-plugin
module.exports = {"separator":"Section_separator__TTdQA"};